module.exports = __webpack_public_path__ + "img/iphone-gen2.7435f009.svg";